export const PageNotFound = () => {
    return (
        <div style={{ display: 'flex', justifyContent: "center", alignItems: 'center', width: '100%', height: '100%' }}>
            <h4>Page Not Found!</h4>
        </div>
    )
}
